export default __webpack_public_path__ + "checkmark.svg";